import { toPersistentStream } from '@ardoq/rxbeach';
import { distinctUntilChanged, map } from 'rxjs';
import { isEqual } from 'lodash';
import type { FeatureContext } from '@ardoq/features';
import { featureContext$ } from 'streams/featureContext$';
import {
  type MetaInfo,
  MetaInfoViewStatus,
} from 'streams/views/mainContent/types';
import { getEnabledDefinitions, toMetaInfo } from './metaInfoTabs';
import { WORKSPACE_MODE_VIEW_DEFINITIONS } from './metaInfoConsts';

const isDeprecatedView = ({ viewStatus }: MetaInfo): boolean =>
  viewStatus === MetaInfoViewStatus.DISCONTINUED ||
  viewStatus === MetaInfoViewStatus.SOON_TO_BE_DISCONTINUED;

// A discontinued view is past its kill date, so only views still running keep one.
const withPendingKillDate = ({ killDate, ...view }: MetaInfo): MetaInfo =>
  view.viewStatus === MetaInfoViewStatus.SOON_TO_BE_DISCONTINUED
    ? { ...view, killDate }
    : view;

// Not taken from workspaceModeViews$: that list drops the views quick start
// hides, and a stored slide or template still names its view either way.
const getDeprecatedViews = (featureContext: FeatureContext): MetaInfo[] =>
  getEnabledDefinitions(WORKSPACE_MODE_VIEW_DEFINITIONS, featureContext)
    .map(definition => toMetaInfo(definition, featureContext))
    .filter(isDeprecatedView)
    .map(withPendingKillDate);

export const deprecatedViews$ = toPersistentStream<MetaInfo[]>(
  'deprecatedViews$',
  featureContext$.pipe(map(getDeprecatedViews), distinctUntilChanged(isEqual)),
  []
);
